var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandAtlassianStyleBrand = function SvgBrandAtlassianStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandAtlassianStyleBrand__clip0_118_367279)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandAtlassianStyleBrand__paint0_linear_118_367279)",
    d: "M6.888 10.76c-.352-.387-.88-.352-1.125.105L.066 22.293c-.21.457.106.984.598.984h7.947a.65.65 0 0 0 .597-.387c1.723-3.55.668-8.93-2.32-12.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M11.074.352c-3.2 5.063-2.989 10.654-.879 14.874 2.11 4.219 3.727 7.419 3.833 7.665a.65.65 0 0 0 .597.387h7.947c.492 0 .844-.528.598-.985 0 0-10.69-21.378-10.97-21.906-.212-.492-.81-.527-1.126-.035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandAtlassianStyleBrand__paint0_linear_118_367279",
    x1: 10.007,
    x2: 3.984,
    y1: 12.507,
    y2: 22.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandAtlassianStyleBrand__clip0_118_367279"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandAtlassianStyleBrand);
export { ForwardRef as ReactComponent };